import React from 'react';
import { formatAmountForDisplay } from '../../flows/shared/utils';
import styles from './style.css';

export const renderAdditionalSectionTable = (
  group,
  accountType,
  totalAccountBalance
) => (
  <table>
    <tbody>
      <tr>
        <th>{accountType}</th>
        <th>Est. available assets</th>
      </tr>
      {group.map(account => (
        <tr key={account.agreementID}>
          <td>
            {account.fundName} ({account.ticker})
          </td>
          <td>{formatAmountForDisplay(account.balanceAsOf)}</td>
        </tr>
      ))}
      <tr className="total-assets-row">
        <td>Est. total assets:</td>
        <td>{formatAmountForDisplay(totalAccountBalance)}</td>
      </tr>
    </tbody>
    <style jsx>{styles}</style>
  </table>
);

export const getChosenFundAgreementId = (selectedAccount, chosen) =>
  (selectedAccount && selectedAccount.map(account => account.agreementID)[0]) ||
  (chosen && chosen.map && chosen.map(fund => fund.agreementID)[0]);

export const checkIfChosenFundIsInExistingFund = (
  existingAgreements,
  chosenFundAgreementId
) =>
  Object.values(existingAgreements)
    .flat()
    .map(account => account.agreementID)
    .includes(chosenFundAgreementId);
